import type { DocumentReference, Query } from "firebase/firestore";
import { listenToDocument, listenToQuery } from "./FirebaseListeners";
import type { SetState } from "./utils/react.util";

export function listenToDocumentToState<T>(
    document: DocumentReference,
    setState: SetState<T | undefined>,
) {
    return listenToDocument<T>(document, (doc) => {
        setState(doc);
    });
}

export function listenToQueryToState<T>(
    query: Query,
    setState: SetState<T[] | undefined>,
) {
    return listenToQuery<T[]>(query, (documents) => {
        setState([...documents]);
    });
}
